import { ResponsiveImageSpec, AspectRatio, MediaQuery } from '../../utils/ImageUtils';
import { AVideoAspectRatio } from '../../atoms/AVideo/AVideo.types';
import { OCarouselGalleryHeroImageScale } from './OCarouselGalleryHero.types';

interface VideoAspectRatios {
  desktop: AVideoAspectRatio;
  mobile: AVideoAspectRatio;
}

const RENDITION_SPECS_MAP: Record<OCarouselGalleryHeroImageScale, ResponsiveImageSpec[]> = {
  [OCarouselGalleryHeroImageScale.Large]: [
    { media: MediaQuery.MIN_WIDTH_MD, aspectRatio: AspectRatio.CLASSIC_HOR, imgWidthPx: 1200 },
    { media: MediaQuery.MAX_WIDTH_SM, aspectRatio: AspectRatio.CLASSIC_VER, imgWidthPx: 576 },
  ],
  [OCarouselGalleryHeroImageScale.Medium]: [
    { media: MediaQuery.MIN_WIDTH_MD, aspectRatio: AspectRatio.WIDE_HOR, imgWidthPx: 1200 },
    { media: MediaQuery.MAX_WIDTH_SM, aspectRatio: AspectRatio.SQUARE, imgWidthPx: 576 },
  ],
  [OCarouselGalleryHeroImageScale.Small]: [
    { media: MediaQuery.MIN_WIDTH_MD, aspectRatio: AspectRatio.FEATURE_HOR, imgWidthPx: 1200 },
    { media: MediaQuery.MAX_WIDTH_SM, aspectRatio: AspectRatio.SQUARE, imgWidthPx: 576 },
  ],
};

const VIDEO_ASPECT_RATIOS_MAP: Record<OCarouselGalleryHeroImageScale, VideoAspectRatios> = {
  [OCarouselGalleryHeroImageScale.Large]: {
    desktop: AVideoAspectRatio.Ratio3x2,
    mobile: AVideoAspectRatio.Ratio2x3,
  },
  [OCarouselGalleryHeroImageScale.Medium]: {
    desktop: AVideoAspectRatio.Ratio16x9,
    mobile: AVideoAspectRatio.Ratio1x1,
  },
  [OCarouselGalleryHeroImageScale.Small]: {
    desktop: AVideoAspectRatio.Ratio5x2,
    mobile: AVideoAspectRatio.Ratio1x1,
  },
};

export function getRenditionSpecsForScale(imageScale: OCarouselGalleryHeroImageScale): ResponsiveImageSpec[] {
  return RENDITION_SPECS_MAP[imageScale] ?? RENDITION_SPECS_MAP[OCarouselGalleryHeroImageScale.Large];
}

export function getVideoAspectRatios(imageScale: OCarouselGalleryHeroImageScale): VideoAspectRatios {
  return VIDEO_ASPECT_RATIOS_MAP[imageScale] ?? VIDEO_ASPECT_RATIOS_MAP[OCarouselGalleryHeroImageScale.Large];
}
